import React, { useEffect } from 'react';

import { useLayoutStore } from "../store/useLayoutStore";

const NonAuthLayout = ({ children }) => {
    const layoutModeType = useLayoutStore(state => state.layoutModeType);

    useEffect(() => {
        if (layoutModeType === "dark") {
            document.body.setAttribute("data-layout-mode", "dark");
        } else {
            document.body.setAttribute("data-layout-mode", "light");
        }
        return () => {
            document.body.removeAttribute("data-layout-mode")
        }
    }, [layoutModeType]);
    return (
        <div className="min-h-screen bg-slate-50">
            {children}
        </div>
    );
};

export default NonAuthLayout;